import { indexActionTypes } from "../actions/indexActions";
const initState = {
  initTime: 0,
  headerIndexes: ["VNINDEX", "VN30", "VNXALL", "HNXINDEX", "HNXUPCOMINDEX"],
  expandIndexesHose: ["VNINDEX", "VN30", "VN100", "VNXALL", "VNMID", "VNSI", "VNSML", "VNDIAMOND", "VNFINLEAD", "VNX50"],
  expandIndexesHNX: ["HNXINDEX"],

  indexInfos: [
    // { counter: 0, code: 'VNI', name: "VN-Index", prior_index: 0, current_index: 0, change_index: 0, pct_change_index: 0, change_color: 0, total_volume: 0, total_value: 0, up: 0, up_ceil: 0, down: 0, down_floor: 0, nochange: 0, status: '', status_str: '', status_str_en: '' },
    // { counter: 0, code: 'VN30', name: "VN30-Index", prior_index: 0, current_index: 0, change_index: 0, pct_change_index: 0, change_color: 0, total_volume: 0, total_value: 0, up: 0, up_ceil: 0, down: 0, down_floor: 0, nochange: 0, status: '', status_str: '', status_str_en: '' },
    // { counter: 0, code: 'VNA', name: "VNALL-Index", prior_index: 0, current_index: 0, change_index: 0, pct_change_index: 0, change_color: 0, total_volume: 0, total_value: 0, up: 0, up_ceil: 0, down: 0, down_floor: 0, nochange: 0, status: '', status_str: '', status_str_en: '' },
    // { counter: 0, code: 'HNX', name: "HNX-Index", prior_index: 0, current_index: 0, change_index: 0, pct_change_index: 0, change_color: 0, total_volume: 0, total_value: 0, up: 0, up_ceil: 0, down: 0, down_floor: 0, nochange: 0, status: '', status_str: '', status_str_en: '' },
    // { counter: 0, code: 'UPCOM', name: "UPCOM-Index", prior_index: 0, current_index: 0, change_index: 0, pct_change_index: 0, change_color: 0, total_volume: 0, total_value: 0, up: 0, up_ceil: 0, down: 0, down_floor: 0, nochange: 0, status: '', status_str: '', status_str_en: ''},
  ],
  indexChart: {},
  basketIndex: {},
  statisticChart: {},
  derivativeChart: [],
};

export const indexReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case indexActionTypes.INDEX_UPDATEDATA:
      return {
        ...state,
        indexInfos: payload.data,
        initTime: payload.isInit ? new Date().getTime() : state.initTime,
      };
    case indexActionTypes.INDEX_UPDATECHARTDATA:
      return {
        ...state,
        indexChart: payload,
      };
    case indexActionTypes.INDEX_UPDATEBASKETINDEX:
      return {
        ...state,
        basketIndex: payload,
        initTime: new Date().getTime(),
      };
    case indexActionTypes.INDEX_UPDATESTATISTICCHART:
      return {
        ...state,
        statisticChart: payload,
      };
    case indexActionTypes.INDEX_UPDATEDERIVATIVECHART:
      return {
        ...state,
        derivativeChart: payload,
      };
    default:
      return state;
  }
};
